import httpUtil from "@/utils/httpUtil";

/***添加页面类别 */
export const addPageClass = async params => httpUtil.post("/pageClass", params);

/**修改页面类别**/
export const updatePageClass = async params => httpUtil.post("/pageClass", params);

/***列表 */
export const pageClassList = async params => httpUtil.get("/pageClass", params);

export const noPage = async params => httpUtil.get("/pageClass/noPage", params);
export const pageClass = async params => httpUtil.get("/crk/app/getPageClass", params);

/***删除 */
export function deleteCustomPageClass(id) {
    return httpUtil.delete(`/pageClass/delete/${id}`)
}

export function deleteStoreClass(id) {
    return httpUtil.delete(`/pageClass/store/delete/${id}`)
}

/****分类绑定页面/图片****/
export const bindPageClass = async params=> httpUtil.post("/pageClass/bind", params);

/***新增/编辑部门  ****/
export const fetchAddOrEditDep = async params => httpUtil.post("/department/addOrupdate", params);

/***部门列表****/
export const fetchDepList = async params => httpUtil.get("/department", params);
export const fetchAllDepList = async params => httpUtil.get("/department/queryNoPage", params);
export const fetchDelDept = async params => httpUtil.post("/department/deleteDept", params);

export const fetchClassCount = async params => httpUtil.get("/pageClass/getStoreClassNum", params);

export const fetchClassDetail = async params => httpUtil.get("/pageClass/detail", params);

export const fetchClassLevelTree = async params => httpUtil.get("/pageClass/treeLevel", params);
export const fetchClassTree = async params => httpUtil.get("/pageClass/tree", params);
export const fetchClassPage = async params => httpUtil.get("/pageClass/page", params);

export const fetchEnableClass = async params => httpUtil.post("/pageClass/enableClass", params);
export const changeWarning = async params => httpUtil.get("/pageClass/changeWarning", params);
export const pageWarn = async params => httpUtil.get("/pageClass/pageWarn", params);
export const addWarn = async params => httpUtil.get("/pageClass/addWarn", params);
export const hzpLink = async params => httpUtil.get("/pageClass/getHzpLink", params);
